import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiPublico from '../../services/apiPublico';
import { chaveTokenComprador } from './LoginComprador';
import s from '../Loja.module.css';

const BACKEND_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001/api').replace(/\/api$/, '');

export default function AssistirCurso() {
  const { slug, produtoId } = useParams();
  const navigate = useNavigate();
  const [curso, setCurso] = useState(null);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(chaveTokenComprador(slug));
    if (!token) {
      navigate(`/loja/${slug}/entrar?voltar=${encodeURIComponent(`/loja/${slug}/assistir/${produtoId}`)}`, { replace: true });
      return;
    }
    apiPublico.get(`/catalogo/${slug}/cursos/${produtoId}/assistir`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setCurso(data))
      .catch(err => {
        if (err.response?.status === 401) {
          localStorage.removeItem(chaveTokenComprador(slug));
          navigate(`/loja/${slug}/entrar?voltar=${encodeURIComponent(`/loja/${slug}/assistir/${produtoId}`)}`, { replace: true });
        } else {
          setErro(err.response?.data?.erro || 'Não foi possível carregar o vídeo.');
        }
      })
      .finally(() => setCarregando(false));
  }, [slug, produtoId, navigate]);

  if (carregando) return <div style={{ padding: 40, textAlign: 'center' }}>Carregando...</div>;
  if (erro) return <div style={{ padding: 40, textAlign: 'center', color: '#b91c1c' }}>{erro}</div>;
  if (!curso) return null;

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px 16px' }}>
      {curso.descricao_curso && <h2 style={{ marginBottom: 4 }}>{curso.descricao_curso}</h2>}
      {curso.duracao_min && <p style={{ color: '#666', fontSize: 13, marginBottom: 16 }}>{curso.duracao_min} min</p>}
      <video
        controls
        controlsList="nodownload"
        onContextMenu={e => e.preventDefault()}
        style={{ width: '100%', borderRadius: 8, background: '#000' }}
        src={`${BACKEND_URL}${curso.stream_url}`}
      />
      <p style={{ marginTop: 12, fontSize: 12, color: '#999' }}>
        Este link é pessoal e expira em alguns minutos — se a página ficar muito tempo aberta, recarregue pra continuar assistindo.
      </p>
    </div>
  );
}
